<template>
    <v-container grid-list-md text-xs-center>
        <div v-html="$storeCandidature.configurationClient.ParamFormulaire.CTApiecesJointes" class="mt-2"></div>
        <v-layout row wrap xs12>
            <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'List of attachments' : 'Liste des pièces jointes :'}}</h3>
            <!-- debut dialog -->
            <v-dialog v-model="dialog" max-width="80%">
                <template v-slot:activator="{ on }">
                </template>
                <v-card>
                    <v-toolbar color="cyan darken-4" dark>
                        <v-toolbar-title>
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Add new attachement' : 'Ajouter une pièce jointe'}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout row wrap xs12>
                                <v-flex xs4>
                                    <v-combobox class="pt-0" v-model="editedItem.Type"
                                                :label="$storeCandidature.langueFormulaire == 'en' ? 'Document type' : 'Type de pièce'"
                                                :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                item-value="Id"
                                                :title="editedItem.Type && ($storeCandidature.langueFormulaire == 'en' ? editedItem.Type.Lang01Tip : editedItem.Type.Lang00Tip)"
                                                readonly>
                                    </v-combobox>
                                </v-flex>
                                <v-flex xs8 text-center>
                                    <!--cutom update button AGU-->
                                    <upload-btn class="mr-10" color="success" :loading="uploadFileLoading" :selectedFileName="this.editedItem.NomPieceJointe"
                                                :defaultButtonText="$storeCandidature.langueFormulaire == 'en' ? 'Select document to upload':'Sélectionner votre document'"
                                                @file-update="selectFile" :ignoredFiles=$storeCandidature.constantes.formatPjNonSupporte>
                                    </upload-btn>
                                </v-flex>
                                <v-flex xs5 text-xs-center>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap xs12>
                                <span v-if="editedItem.NomPieceJointe">{{$storeCandidature.langueFormulaire == 'en' ? 'Selected file:' : 'Fichier Sélectionné : '}}</span>
                                <span v-if="editedItem.NomPieceJointe" style="background-color:lightgray">{{editedItem.NomPieceJointe}}</span>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" dark @click="close">{{$storeCandidature.langueFormulaire == 'en' ? 'Cancel' : 'Annuler'}}</v-btn>
                        <v-btn color="primary" dark :loading="uploadFileLoading" @click="save">{{$storeCandidature.langueFormulaire == 'en' ? 'Submit' : 'Valider'}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- fin dialog -->
            <hr size="5" width="100%" color="secondary">
        </v-layout>
        <!-- Début Pièces jointe -->
        <p class="mt-3 ml-2 text-xs-left title teal--text text--darken-2" v-if="!$storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire && !$storeCandidature.configurationClient.ParamFormulaire.ValidationPJNonObligatoire">
            {{$storeCandidature.langueFormulaire == 'en' ? 'Your supporting documents will be validated later by the admissions department.' : 'Vos pièces justificatives seront validées ultérieurement par le service des admissions.'}}
            <br />
            {{$storeCandidature.langueFormulaire == 'en' ? 'Please proceed to the next step after adding the documents.' : 'Merci de passer à l’étape suivante après l\'ajout des documents.'}}
        </p>
        <p class="mt-3 ml-2 text-xs-left title teal--text text--darken-2" v-if="!$storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire && $storeCandidature.configurationClient.ParamFormulaire.ValidationPJNonObligatoire">
            {{$storeCandidature.langueFormulaire == 'en' ? 'Please provide us with the following documents (only the documents indicated with an * are compulsory):' : 'Merci de procéder à l\'ajout des documents (seuls les documents indiqués avec une * sont obligatoires):'}}
        </p>
        <p class="mt-3 ml-2 text-xs-left title teal--text text--darken-2" v-if="$storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire && $storeCandidature.configurationClient.ParamFormulaire.ValidationPJNonObligatoire">
            {{$storeCandidature.langueFormulaire == 'en' ? 'You can add documents.' : 'Vous pouvez ajouter les documents.'}}
        </p>
        <v-data-table :headers="headers" :items="$storeCandidature.sasCandidature.ListePiecesJustificatives" class="elevation-1" disable-pagination hide-default-footer>
            <template v-slot:no-data>
                <v-alert :value="true" color="grey lighten-3" icon="warning">{{$storeCandidature.langueFormulaire == 'en' ? 'List empty' : 'La liste est vide'}}</v-alert>
            </template>
            <template v-slot:item={item}>
                <tr>
                    <th class="text-xs-left">
                        {{item.Type ? ($storeCandidature.langueFormulaire == 'en' ? item.Type.Lang01 : item.Type.Lang00): ''}}
                        <span class="red--text" v-if="$storeCandidature.configurationClient.ParamFormulaire
                              && $storeCandidature.configurationClient.ParamFormulaire.AjoutPJNonObligatoire == false
                              && item.Type && item.Type.Code !='F'">*</span>
                        <v-icon v-if="$storeCandidature.langueFormulaire == 'en' && item.Type.Lang01Tip  != ''" small color="primary" :title="item.Type && item.Type.Lang01Tip">help</v-icon>
                        <v-icon v-if="$storeCandidature.langueFormulaire == 'fr' && item.Type.Lang00Tip != '' " small color="primary" :title="item.Type && item.Type.Lang00Tip">help</v-icon>
                    </th>
                    <th class="text-xs-left">
                        <v-icon v-if="item.UrlFichier" small color="info" class="mr-2" title="Afficher le document"
                                @click="$storeCandidature.afficherAnnexe(item.UrlFichier)">
                            visibility
                        </v-icon>
                        {{item.NomPieceJointe}}
                    </th>
                    <th class="text-xs-left">
                        <span v-if="etat_PieceJointe(item) == 1" style="color:green">{{$storeCandidature.langueFormulaire == 'en' ? 'Approved':'Validée'}}</span>
                        <span v-if="etat_PieceJointe(item) == 4" style="color:darkorange">
                            <!--title={{$storeCandidature.langueFormulaire == 'en' ? 'Your supporting documents will be validated later by the admissions department. Please continue to the next step after submitting the documents.' : 'Vos pièces justificatives seront validées ultérieurement par le service des admissions. Merci de passer à l\'étape suivante après l\'envoi des documents.'}}>-->
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Awaiting validation' : 'A valider'}}
                        </span>
                        <span v-if="etat_PieceJointe(item) == 2" style="color:darkred">
                            <!--title={{$storeCandidature.langueFormulaire == 'en' ? 'This document is not yet sent, the following button will start sending.' : 'Ce document n\'est pas encore envoyé, le bouton suivant déclanchera l\'envoi.'}}>-->
                            {{$storeCandidature.langueFormulaire == 'en' ? 'New':'Nouveau'}} ({{item.Taille}} Mo)
                        </span>
                        <span v-if="etat_PieceJointe(item) == 3" style="color:red">{{$storeCandidature.langueFormulaire == 'en' ? 'Missing' : 'Manquante'}}</span>
                    </th>
                    <th>
                        <v-icon small class="mr-2" @click="editItem(item)" :disabled="item.Valide">edit</v-icon>
                        <v-icon small @click="deleteItem(item)" :disabled="item.Valide || !item.NomPieceJointe || item.NomPieceJointe == ''">delete</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
        <!-- fin liste Pièces jointes -->
        <v-snackbar v-model="snackbar" color="error">
            {{messageSnackbar}}
        </v-snackbar>
    </v-container>
</template>
<script>
    //import UploadButton from 'vuetify-upload-button';
    import UploadButton from "../components/CustomFileUpload"

    export default {
        components: {
            'upload-btn': UploadButton
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,

                // Dialog et flag
                dialog: false,
                uploadFileLoading: false,
                snackbar: false,
                messageSnackbar: "Error",


                //Header list
                headers: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Attachment type' : 'Type de pièce', value: 'type' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'File' : 'Fichier', value: 'fichier' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Status' : 'Statut', value: 'etat', sortable: false },
                    { text: '', value: 'actions', sortable: false }
                ],

                editedIndex: -1,
                editedItem: {
                    Type: null,
                    NomPieceJointe: '',
                    DonneePieceJointe: null,
                    Taille: 0,
                    Valide: false,
                    Etat: 'Manquante',
                    Supprimer: false
                },

                pieceManquante: 1,
                index: 0,
            }
        },

        methods: {
            // vérifier L'état de la pièce jointe : 1 = Validée, 2 = A valider, 3 = Manquante
            etat_PieceJointe(document) {
                // Validé
                if (document.Valide) {
                    return 1;
                }
                // Nouveau
                if (document.DonneePieceJointe) {
                    return 2
                }
                // Manquant
                if (!document.NomPieceJointe) {
                    return 3;
                }
                // A valider
                if (!document.Valide) {
                    return 4;
                }

                return 0;
            },

            editItem(item) {
                this.editedIndex = this.$storeCandidature.sasCandidature.ListePiecesJustificatives.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {
                if (confirm(this.$storeCandidature.langueFormulaire == 'en' ? 'Are you sure you want to delete this attachment?' : 'Etes-vous sûr de vouloir supprimer cette pièce jointe?')) {
                    this.editedIndex = this.$storeCandidature.sasCandidature.ListePiecesJustificatives.indexOf(item)
                    this.editedItem.Supprimer = true
                    this.editedItem.Id = item.Id
                    this.editedItem.Type = item.Type
                    this.editedItem.NomPieceJointe = ''
                    this.editedItem.DonneePieceJointe = null
                    this.editedItem.UrlFichier = null
                    Object.assign(this.$storeCandidature.sasCandidature.ListePiecesJustificatives[this.editedIndex], this.editedItem)
                    this.calculerTailleTotaleFichiers()
                    this.$storeCandidature.candidatureChanged = true
                }
            },

            // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
            async selectFile(file) {
                if (file) {
                    this.uploadFileLoading = true;
                    this.editedItem.NomPieceJointe = file.name;
                    await this.readFile(file, this.editedItem);
                    this.editedItem.Taille = new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(file.size / 1048576)
                    this.calculerTailleTotaleFichiers()
                    setTimeout(this.stopLoadinMode, 2000)
                }
                else {
                    this.editedItem.NomPieceJointe = '';
                    this.editedItem.DonneePieceJointe = null;
                }
            },

            // Lire le contenu d'un fichier la data de l'élément en cours
            readFile(file, monFichier) {
                var reader = new FileReader();

                // Listener de fin de lecture
                reader.onloadend = function () {
                    // Recupérer la chaine lise dans le data de l'élément en cours
                    monFichier.DonneePieceJointe = btoa(reader.result);
                }

                // Lancer la lecture du ficheir
                reader.readAsBinaryString(file);
            },

            // Arrêter
            stopLoadinMode() {

                this.uploadFileLoading = false;
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, {
                        Type: null,
                        NomPieceJointe: '',
                        DonneePieceJointe: null,
                        Taille: 0,
                        Valide: false,
                        Supprimer: false
                    })
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                // Si aucun fichier n'est sélectionné, on ne valide rien
                if (!this.editedItem.NomPieceJointe) {
                    //alert(this.$storeCandidature.langueFormulaire == 'en' ? 'No file selected' : 'Aucun fichier n\'a été sélectionné')
                    this.messageSnackbar = this.$storeCandidature.langueFormulaire == 'en' ? 'No file selected' : 'Aucun fichier n\'a été sélectionné'
                    this.snackbar = true
                    return;
                }

                if (this.editedIndex > -1) {
                    this.editedItem.Supprimer = false;
                    this.uploadFileLoading = true;

                    // appeler le webservice de chargement du ficheir
                    this.envoyerFichierAuSeveur(this.editedItem).then()
                        .then(response => {
                            if (response.data) {
                                this.editedItem = response.data
                                Object.assign(this.$storeCandidature.sasCandidature.ListePiecesJustificatives[this.editedIndex], this.editedItem)

                                // Fermer la fenêtre du dialog
                                this.uploadFileLoading = false
                                this.close()
                                this.$storeCandidature.ValiderListesPiecesJointes();
                            }
                            else {
                                this.uploadFileLoading = false
                            }
                        }).catch(() => {
                            //aclert("Impossible d'ajouter ce fichier merci de le resauvegarder ou l'envoyer dans un autre format.")
                            this.uploadFileLoading = false
                            this.messageSnackbar = this.$storeCandidature.langueFormulaire == 'en' ? 'Cannot add this file. Please retry or send it in another format.' : 'Impossible d\'ajouter ce fichier. Merci de le resauvegarder ou l\'envoyer dans un autre format.'
                            this.snackbar = true
                        })
                } else {
                    this.editedItem.Supprimer = false;
                    this.$storeCandidature.sasCandidature.ListePiecesJustificatives.push(this.editedItem)
                }
            },

            // Calculer la taille totale sélectionné
            calculerTailleTotaleFichiers() {
                this.$storeCandidature.tailleUpload = 0;
                this.$storeCandidature.sasCandidature.ListePiecesJustificatives.forEach(fichier => {
                    if (fichier && fichier.Taille) {
                        this.$storeCandidature.tailleUpload = new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(Number(this.$storeCandidature.tailleUpload) + Number(fichier.Taille))
                    }
                });
            },

            // Vérifier si la candidature doit être redirigé vers un concours
            envoyerFichierAuSeveur(pj) {
                return this.$http.post("UploadPieceJustificative", JSON.stringify(pj), {
                    params: {
                        CdtId: this.$storeCandidature.sasCandidature
                            && this.$storeCandidature.sasCandidature.IdCrypte ? this.$storeCandidature.sasCandidature.IdCrypte : null,
                        Key: this.$storeCandidature.sasCandidature
                            && this.$storeCandidature.sasCandidature.KeyCrypte ? this.$storeCandidature.sasCandidature.KeyCrypte : null
                    }
                })
            },
        },

    }
</script>